import {
  Box,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CreateForm } from ".";

type ValueType = CreateForm["params"]["useAsKey"];

type Params = {
  title: string;
  value: ValueType;
  fileOrFolder: CreateForm["params"]["type"];
  onChange: (newValue: ValueType) => void;
  "data-testid"?: string;
};
export default function SelectUseAs({
  title,
  value,
  fileOrFolder,
  onChange,
  "data-testid": dataTestId,
}: Params) {
  const { t } = useTranslation("datasets");
  const type = t(`syncForm.${fileOrFolder === "FILE" ? "file" : "folder"}`);
  const SelectDisplayProps = {
    ...(dataTestId && { "data-testid": dataTestId }),
  } as React.HTMLAttributes<HTMLDivElement>;

  const onChangeHandler: SelectProps["onChange"] = e => {
    const { value } = e.target;
    onChange(value as "id" | "name");
  };

  return (
    <Box display="flex" alignItems="center" mt={2} gridGap="1rem">
      <Box>
        <Typography>{title}</Typography>
      </Box>
      <Box>
        <Select
          variant="outlined"
          value={value}
          onChange={onChangeHandler}
          SelectDisplayProps={SelectDisplayProps}
        >
          <MenuItem
            value="id"
            {...(dataTestId && { "data-testid": `${dataTestId}-option-id` })}
          >
            {t("syncForm.theID", { type }) as string}
          </MenuItem>
          <MenuItem
            value="name"
            {...(dataTestId && { "data-testid": `${dataTestId}-option-name` })}
          >
            {t("syncForm.theName", { type }) as string}
          </MenuItem>
        </Select>
      </Box>
    </Box>
  );
}
